export default __webpack_public_path__ + "static/media/0111.375654e7.jpg";